import React from "react";
import HeaderDefs from "./HeaderDefs";
import Logo from "./Logo";
import styled from "styled-components";

const StyledText = styled.text`
  font-family: "hemi";
`;

const Header = () => {
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 244.02">
        <HeaderDefs />
        <path fill="#f39200" d="M0 173.37h1080v15.03H0z" />
        <path fill="#3c2415" d="M0 68.16h1080v105.21H0z" />
        <path fill="url(#a)" d="M0 68.16h1080V188.4H0z" />
        <StyledText
          transform="translate(232.52 118.71)"
          fill="#f39200"
          stroke="#3c2415"
          strokeLinejoin="round"
          fontSize="108.87"
          strokeWidth="18.06"
          // // fontFamily="hemi, Hemi Head"           fontFamily="Hemi"
          // fontFamily="Hemii"
          fontWeight="700"
          fontStyle="italic"
          letterSpacing=".05em"
        >
          REFUEL
        </StyledText>
        <StyledText
          transform="translate(435.75 207.12)"
          fill="#f39200"
          stroke="#3c2415"
          strokeLinejoin="round"
          fontSize="108.87"
          strokeWidth="18.06"
          // fontFamily="hemi, Hemi Head"
          // fontFamily="Hemii"
          fontWeight="700"
          fontStyle="italic"
          letterSpacing=".05em"
        >
          GROW
        </StyledText>
        <StyledText
          transform="translate(232.52 118.71)"
          fontSize="108.87"
          fill="#fff"
          // fontFamily="hemi, Hemi Head"
          // fontFamily="Hemii"
          fontWeight="700"
          fontStyle="italic"
          letterSpacing=".05em"
        >
          REFUEL
        </StyledText>
        <StyledText
          transform="translate(435.75 207.12)"
          fontSize="108.87"
          fill="#fff"
          // fontFamily="hemi, Hemi Head"
          // fontFamily="Hemii"
          fontWeight="700"
          fontStyle="italic"
          letterSpacing=".05em"
        >
          GROW
        </StyledText>
        <path
          d="M797.37 128.93a9 9 0 0 0-7.65-4.23H773.5a9 9 0 0 0-8.18 5.21l-9.51 20.39-.72-17a9 9 0 0 0-9-8.65h-16.57a9 9 0 0 0-8.1 5l-10.36 21-.39-17.19a9 9 0 0 0-9-8.83h-17a9 9 0 0 0-8.76 6.92 15.21 15.21 0 0 0-2.72-2.92 17.68 17.68 0 0 0-8.51-3.59 9.09 9.09 0 0 0 2.18-4.22L670 106a9 9 0 0 0-8.83-10.9h-21.74l10.11-47.89a9 9 0 0 0-8.84-10.89h-16.54a9 9 0 0 0-8.71 6.68 9 9 0 0 0-8.71-6.68h-54.65a9 9 0 0 0-8.44 5.83 9.22 9.22 0 0 0-1.42-2.49 9.05 9.05 0 0 0-7-3.34h-15.91a9 9 0 0 0-8.83 7.16l-11 51.84h-10.9l10.17-48.11a9 9 0 0 0-8.83-10.89h-16.55a9 9 0 0 0-7.62 4.19 8.72 8.72 0 0 0-.61-.85 9 9 0 0 0-7-3.34H403.6a9 9 0 0 0-8.76 6.87 9.14 9.14 0 0 0-1.75-3.53 9.05 9.05 0 0 0-7-3.34h-54.67a9 9 0 0 0-8.83 7.15l-1.88 8.85a15.91 15.91 0 0 0-5.84-12c-3.36-2.69-7.88-4-13.82-4h-46.81a9 9 0 0 0-8.84 7.15l-3 14.37a8.92 8.92 0 0 0-.14 2.91 8.82 8.82 0 0 0-.95 2.54l-11.43 53.88a9 9 0 0 0 8.83 10.91h16.55a9 9 0 0 0 8.83-7.17l4.26-20.27h8.95l-3.45 16.57a9 9 0 0 0 8.84 10.87h16.51a9 9 0 0 0 8.33-5.57 9 9 0 0 0 8.32 5.57h54.65a9 9 0 0 0 8.76-6.88 9.22 9.22 0 0 0 1.74 3.5 9 9 0 0 0 7 3.35h17.09a9 9 0 0 0 8.83-7.16l4.69-22.13h20.45a9 9 0 0 0 8.83-7.15l2.61-12.3a9 9 0 0 0-6.1-10.49h10.66a9 9 0 0 0 4.33-1.11l-7.69 36.45a24.3 24.3 0 0 0-.62 3.69C451 108.92 451 110 451 111c0 7 3.1 11 5.7 13.09a15.84 15.84 0 0 0 3.39 2.07 19.26 19.26 0 0 0-7.12 4.18c-3.61 3.37-6.11 8.21-7.46 14.41l-10.1 47.94a30.19 30.19 0 0 0-.87 6.84c0 6.91 3.17 10.9 5.84 13 3.31 2.65 7.77 3.94 13.64 3.94h46.27a9 9 0 0 0 8.66-6.48 9 9 0 0 0 8.65 6.48h16.5a9 9 0 0 0 8.84-7.17l4.26-20.3h8.95l-3.45 16.56a9 9 0 0 0 8.84 10.87h16.55a9 9 0 0 0 8.83-7.18l1.24-5.9a15.25 15.25 0 0 0 5.46 9.14c3.31 2.65 7.77 3.94 13.64 3.94H644c7 0 12.52-1.86 16.51-5.54 3.67-3.38 6.21-8.23 7.56-14.47l8.47-40.17 2 51.5a9 9 0 0 0 9 8.68H706a9 9 0 0 0 8-4.93l11.51-22.5 1 18.88a9 9 0 0 0 9 8.56h18.62a9 9 0 0 0 8.13-5.1l35.6-73.7a9 9 0 0 0-.49-8.71zM314.45 82.11l-1.1 5.19a16 16 0 0 0-.65-2.17 20.72 20.72 0 0 0 1.75-3.02zm-39.69-11.75l.35-1.64h8l-.36 1.64zm107.59 32a9.19 9.19 0 0 0-1.79-3.69 9.07 9.07 0 0 0-7-3.33h-.84a9 9 0 0 0 2.49-4.55L377.7 79a9 9 0 0 0-5.49-10.27H383a9 9 0 0 0 7.24-3.64zm217.53 19.06a8.86 8.86 0 0 0 1.7 3.33 9 9 0 0 0 7 3.35h.61a18.37 18.37 0 0 0-3 2.24 25.22 25.22 0 0 0-6.59 11.16c-.13-6.71-3.24-10.63-5.86-12.74-.35-.28-.72-.54-1.1-.79a9 9 0 0 0 7.24-6.6zm25.48 62.34l5.64-26.63h10.27l-5.67 26.58zm-104.25-34.62s0 .07-.05.1v-.2a.34.34 0 0 0 .05.1zM524 133a9 9 0 0 0-2-5 8.93 8.93 0 0 0-3.06-2.41 19.32 19.32 0 0 0 4.64-3.11 22.22 22.22 0 0 0 4-5 9 9 0 0 0 1.86 7.22c.16.2.34.38.51.56a9 9 0 0 0-5.72 6.6zm30 24.1h8l-.36 1.65h-8zm-81.92 27.12h-.25v-.13zM516.3 159a8.9 8.9 0 0 0-2-1.8 9.07 9.07 0 0 0 5.61-4.41l-2 9.37a9.18 9.18 0 0 0-1.61-3.16zm75.29 14.59a22.89 22.89 0 0 0 1.7-2.91l-1.06 5a15.67 15.67 0 0 0-.64-2.13zm19.1-108.17L603 102a9 9 0 0 0-8.73-6.75h-.85a8.87 8.87 0 0 0 2.49-4.55l2.46-11.7a9 9 0 0 0-5.5-10.27h10.82a9 9 0 0 0 7-3.35z"
          fill="url(#a)"
        />
        <Logo />
      </svg>
    </>
  );
};

export default Header;
